import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import Shell from "../../../common/components/Shell/Shell";
import AttendancePresenter from "./AttendancePresenter";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../infra/hooks";

function AttendanceController() {
  const { t, i18n } = useTranslation();
  const empName = useAppSelector((state) => state.authSlice.name);
  const empProfilePic = useAppSelector(
    (state) => state.profilePicSlice.profilePic
  );
  const empDesignation = useAppSelector((state) => state.authSlice.designaion);
  return (
    <Shell>
      <Grid
        container
        style={{
          maxWidth: "auto",
          marginLeft: i18n.language == "en" ? "7.25em" : "",
        }}
      >
        <AttendancePresenter
          trans={t}
          i18n={i18n}
          empName={empName}
          empProfilePic={empProfilePic}
          empDesignation={empDesignation}
        />
      </Grid>
    </Shell>
  );
}
export default AttendanceController;
